import { ChangeDetectionStrategy, Component, OnInit, Signal, computed, signal } from '@angular/core';
import { UserApi } from 'api/user/user-api.js';
import { UserDb } from 'lib/cosmos/user/userDb.js';
import { map } from 'rxjs';
import { TypeCoreComponent } from 'src/app/pages/type-routes/type-core.component.js';
import { FormSaveHandler } from 'lib/ui/form/form-save-button.component.js';

@Component({
    selector: 'mod-edit-user-password',
    templateUrl: './edit-user-password.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EditUserPasswordComponent extends TypeCoreComponent<UserDb.IUserItem> implements OnInit {
	public readonly form = {
		password: signal<string | undefined>(undefined)
	};

	public readonly saveHandler = computed<FormSaveHandler>(() => {
		const sharedData = this.sharedData();

		if (!sharedData) {
			return undefined;
		}

		const password = this.form.password();

		if (!password) {
			return undefined;
		}

		const formData: UserApi.IEditUserPasswordRequest = {
			password: password
		};

		return this.dependencies.httpService
			.post<void, UserApi.IEditUserPasswordRequest>((builder) =>
				builder.withCustomApiRoute('user', 'editPassword').withData(formData).withId(sharedData.data.id).build()
			)
			.pipe(
				map((response) => {
					super.notify('Password has been updated');
					this.form.password.set('');
				})
			);
	});

	constructor() {
		super();
	}
}
